module.exports = __webpack_public_path__ + "img/icomoon.3677877.svg";